<script lang="ts">
    import dayjs from 'dayjs';
    import type { Dayjs } from 'dayjs';
    import {
        VpArrowLeftCircleIcon,
        VpArrowRightCircleIcon,
    } from '@decathlon-experience/icons/svelte';
    import { fade } from 'svelte/transition';

    import cn from '$common/utils/cn';
    import {
        getQuantileSizeClass,
        isMonthDatesFull,
        isSelectedMonth,
    } from '$saga/views/Tour/VisibleDates/utils';
    import { formatCurrency } from '$saga/utils/price';
    import {
        MinPriceMonth,
        VisibleDate,
    } from '$saga/views/Tour/VisibleDates/types';
    import { min } from 'lodash';

    export let root,
        prevButton,
        nextButton,
        page,
        range,
        currentActiveMonth: Dayjs,
        totalPages,
        minPricePerMonths: MinPriceMonth[],
        // FIT does not have visibleDates
        visibleDates: VisibleDate[] | undefined = undefined;
</script>

<div
    class="no-scrollbar flex items-center justify-center gap-xs overflow-x-scroll py-xs medium:gap-m desktop:mx-auto desktop:w-fit"
    {...$root}
    use:root
>
    {#if $totalPages > 1}
        <button class="" {...$prevButton} use:prevButton>
            <VpArrowLeftCircleIcon
                class={cn(
                    'size-xl text-content-brand',
                    $page === 1 && 'opacity-[0.38]',
                )}
            />
        </button>
    {/if}

    {#each minPricePerMonths as minPriceMonth, index (minPriceMonth.date)}
        <button
            transition:fade
            on:click={() => (currentActiveMonth = minPriceMonth.date)}
            class={cn(
                'relative w-full max-w-[60px] flex-col items-center justify-center gap-2xs rounded-[20px] border border-solid border-border-quiet p-xs',
                isSelectedMonth(minPriceMonth.date, currentActiveMonth) &&
                    'border-border-brand',
                index >= $range.start && index <= $range.end
                    ? 'flex'
                    : 'hidden',
                minPriceMonth.price == null && 'opacity-[0.38]',
                visibleDates != null &&
                    isMonthDatesFull(visibleDates, minPriceMonth.date) &&
                    'opacity-[0.38]',
            )}
        >
            <span class="px-2xs text-sm">
                {minPriceMonth.date.format('MMM YYYY')}
            </span>
            <span
                class={cn(
                    'h-[1px] w-full border-t border-solid border-border-quiet',
                    isSelectedMonth(minPriceMonth.date, currentActiveMonth) &&
                        'border-border-brand',
                )}
            ></span>
            <span
                class={cn(
                    'whitespace-nowrap text-xs font-semibold',
                    minPriceMonth.price != null &&
                        minPriceMonth.quantile != null &&
                        getQuantileSizeClass(minPriceMonth.quantile),
                )}
            >
                {minPriceMonth.price
                    ? formatCurrency(minPriceMonth.price / 100, false)
                    : '-'}
            </span>
        </button>
    {/each}
    {#if $totalPages > 1}
        <button class="" {...$nextButton} use:nextButton>
            <VpArrowRightCircleIcon
                class={cn(
                    'size-xl text-content-brand',
                    $page === $totalPages && 'opacity-[0.38]',
                )}
            />
        </button>
    {/if}
</div>
